module.exports = __webpack_public_path__ + "img/logo2.d3074c98.png";